import { render, staticRenderFns } from "./SectionColumns.vue?vue&type=template&id=6972fc03&scoped=true&"
import script from "./SectionColumns.vue?vue&type=script&lang=js&"
export * from "./SectionColumns.vue?vue&type=script&lang=js&"
import style0 from "./SectionColumns.vue?vue&type=style&index=0&id=6972fc03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972fc03",
  null
  
)

export default component.exports